import React from 'react';
import { hashHistory, Link } from 'react-router'
import { inject, observer } from "mobx-react";
import LeafletMap from "../../LeafletMap";
import { getCenter } from "../../Map/getCenterLatLng";
import moment from "moment";
import StepRangeSlider from "react-step-range-slider";
import { getDisplayDate } from "../../../libs/date";
import { action, autorun, observable } from "mobx";
import WorkOrderInfoTable from "./WorkOrderInfoTable";

@inject('workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore', 'workOrderStore', 'userStore')
@observer
export default class WorkOrderMapLeaflet extends React.Component {
  state = {
    markers: [],
    markerIcons: [],
    mapCenter: null
  };

  @observable playing = false;
  dispose;
  interval;

  @action
  componentWillMount() {
    this.dispose = autorun(() => {
      this.props.workOrderStore.setDateAndTimeRange(this.props.workOrderStore.filteredWorkOrders);
    });

  }

  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all} = this.props;
  //   this.dispose = autorun(() => {
  //     this.resetMarkers(ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all);
  //   })
  // }
  //
  //
  // componentWillReceiveProps(nextProps) {
  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all} = nextProps;
  //   if(this.props.view_archived !== view_archived || this.props.assigned_to_all !== assigned_to_all)
  //     this.resetMarkers(ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all);
  // }

  componentWillUnmount() {
    if (this.dispose)
      this.dispose();
  }

  resetMarkers = (workOrderStore, workOrderStatusStore, maintenanceTypeStore, priorityStore, view_archived, assigned_to_all, userStore) => {
    const markers = workOrderStatusStore.items.length > 0 && priorityStore.items.length > 0 && maintenanceTypeStore.items.length > 0
      ? workOrderStore.getMarkers({
        statusItems: workOrderStatusStore.items,
        priorityItems: priorityStore.items,
        maintenanceTypeItems: maintenanceTypeStore.items,
        view_archived,
        ticketItems: workOrderStore.items,
        users: userStore.items,
        assigned_to_all
      })
      : [];
    const markerIcons = this.filterMarkerByShow(markers).map(marker => (
      Object.assign({}, {
        id: 'work_order_marker-' + marker.work_orders[0].id,
        station_id: marker.station_id,
        position: [marker.latitude, marker.longitude],
        icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
        iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
        // popupBox: this.getPopupBox(marker)
      })
    ));
    let mapCenter = getCenter(markers);
    this.setState({ markers, mapCenter, markerIcons });
  }

  // componentWillUnmount() {
  //   this.dispose();
  // }
  // getInfoTableData = (markers) => {
  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore} = this.props;
  //   let tickets =  [];
  //   markers.map(item => {
  //     tickets.push(...item.tickets)
  //   });
  //   if(+ticketStore.viewBy === 1){
  //     return ticketStatusStore.items.map(item => {
  //       return {
  //         id: item.id,
  //         caption: item.caption,
  //         color: <i className='fa fa-circle' style={{color: item.color}}/>,
  //         number: tickets ? tickets.filter(ticket => ticket && +ticket.status_id === +item.id).length : '-'
  //       }
  //     });
  //   } else if (+ticketStore.viewBy === 2) {
  //     return ticketReasonStore.items.map(item => {
  //       return {
  //         id: item.id,
  //         caption: item.caption,
  //         color: <i className='fa fa-circle' style={{color: item.color}}/>,
  //         number: tickets ? tickets.filter(ticket => ticket && +ticket.reason_id === +item.id).length : '-'
  //       }
  //     });
  //   } else if (+ticketStore.viewBy === 3) {
  //     return ticketActionStore.items.map(item => {
  //       return {
  //         id: item.id,
  //         caption: item.caption,
  //         color: <i className='fa fa-circle' style={{color: item.color}}/>,
  //         number: tickets ? tickets.filter(ticket => ticket && +ticket.action_id === +item.id).length : '-'
  //       }
  //     });
  //   }
  // };
  // renderSelectInputs = () => {
  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore} = this.props;
  //   let showOptions = null;
  //   switch (+ticketStore.viewBy){
  //     case 1: showOptions = ticketStatusStore.items; break;
  //     case 2: showOptions = ticketReasonStore.items; break;
  //     case 3: showOptions = ticketActionStore.items; break;
  //     default: showOptions = null; break;
  //   }
  //   return (
  //     <div>
  //       <div className="formInput">
  //         <label>View By</label>
  //         <select value={ticketStore.viewBy || ''} onChange={ticketStore.onChangeViewBy}>
  //           {ticketStore.viewByOptions.map(option => (
  //             <option
  //               key={option.id}
  //               value={option.id}
  //             >
  //               {option.name}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  //       <div className="formInput">
  //         <label>Show</label>
  //         <select value={ticketStore.show || ''} onChange={ticketStore.onChangeShow}>
  //           <option value={''}>All</option>
  //           {showOptions && showOptions.map(option => (
  //             <option
  //               key={option.id}
  //               value={option.id}
  //             >
  //               {option.caption}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  //     </div>
  //   )
  // };
  // filterMarkerByShow = (markers) => {
  //   const {ticketStore} = this.props;
  //   if(!!ticketStore.viewBy && !!ticketStore.show){
  //     return markers.filter(marker => {
  //       switch(+ticketStore.viewBy){
  //         case 1: return !!marker.tickets.find(item => item.status_id === +ticketStore.show);
  //         case 2: return !!marker.tickets.find(item => item.reason_id === +ticketStore.show);
  //         case 3: return !!marker.tickets.find(item => item.action_id === +ticketStore.show);
  //         default: return false;
  //       }
  //     });
  //   } else {
  //     return markers
  //   }
  // };

  getFilteredMarkerIcons = markers => markers.reduce((acc, marker) => {
    if (!marker.latitude || !marker.longitude) return acc;
    const { workOrderStore } = this.props;

    if (!!workOrderStore.viewBy && !!workOrderStore.show) {
      switch (+workOrderStore.viewBy) {
        case 1: if (!marker.work_orders.find(item => +item.status_id === +workOrderStore.show)) return acc; else break;
        case 2: if (!marker.work_orders.find(item => +item.priority_id === +workOrderStore.show)) return acc; else break;
        case 3: if (!marker.work_orders.find(item => +item.maintenance_type === +workOrderStore.show)) return acc; else break;
        case 4: if (!marker.work_orders.find(item => +item.assigned_to === +workOrderStore.show)) return acc; else break;
        default: break;
      }
    }

    acc.push({
      id: 'work_order_marker-' + marker.work_orders[0].id,
      station_id: marker.station_id,
      color: marker.color,
      position: [marker.latitude, marker.longitude],
      latitude: marker.latitude, longitude: marker.longitude,
      icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
      iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `
    });
    return acc;
  }, []);

  getPopupBox = marker => {
    const { workOrderStore } = this.props;

    return (
      <div>
        <strong style={{ fontSize: '15px', fontWeight: 'bold' }}>{marker.station_name}</strong><br />
        <span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }}
          onClick={() => this.props.workOrderStore.selectedMarker = null} />
        {!!marker.duration ? <small>{marker.duration}</small> : ''}
        <br />
        <div style={{ maxHeight: '220px', overflowY: 'scroll' }}>
          {marker.work_orders
            .filter(work_order => {
              if (!workOrderStore.show) return true;
              switch (+workOrderStore.viewBy) {
                case 1:
                  return +work_order.status_id === +workOrderStore.show;
                case 2:
                  return +work_order.priority_id === +workOrderStore.show;
                case 3:
                  return +work_order.maintenance_type === +workOrderStore.show;
                case 4:
                  return +work_order.assigned_to === +workOrderStore.show;
                default:
                  return false;
              }
            })
            .map(work_order => (
              <div key={`station-${marker.station_id}-ticket-${work_order.id}`}>
                <Link to={`/monitoring/work_order/tabular/${work_order.id}/view`}>Work Order {work_order.id}</Link>
                <table style={{ padding: '10px' }}>
                  <tbody>
                    <tr>
                      <th>Summary</th>
                      <td>{work_order.title}</td>
                    </tr>
                    <tr>
                      <th>Scheduled Date</th>
                      <td>{moment.utc(work_order.scheduled_date).format('YYYY-MM-DD')}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>{work_order.status && work_order.status.caption}</td>
                    </tr>
                    <tr>
                      <th>Priority</th>
                      <td>{work_order.priority && work_order.priority.caption}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>{work_order.type && work_order.type.caption}</td>
                    </tr>
                    <tr>
                      <th>Assigned to</th>
                      <td>{work_order.user && work_order.user.name}</td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </div>
            ))}
        </div>
      </div>
    )
  };

  onMarkerClick = marker => {
    let workOrderId = marker.id.split('-')[1];
    hashHistory.push(`/monitoring/work_order/tabular/${workOrderId}/view`)
  };

  @action onChangeSelectedTime = value => {
    if (this.interval) {
      clearInterval(this.interval);
      this.playing = false;
      this.interval = null;
    }

    this.props.workOrderStore.setSelectedTime(value);
  }

  @action startInterval = () => {
    const { selectedTime, timeRange, setSelectedTime } = this.props.workOrderStore;

    if (selectedTime === timeRange[timeRange.length - 1].value) {
      setSelectedTime(0);
    }

    if (this.interval) {
      this.playing = false;
      clearInterval(this.interval);
      this.interval = null;
    } else {
      this.playing = true;

      this.interval = setInterval(() => {
        const { selectedTime, timeRange, setSelectedTime } = this.props.workOrderStore;

        if (selectedTime === timeRange[timeRange.length - 1].value) {
          clearInterval(this.interval);

          this.interval = null;
          this.playing = false;
        } else {
          if (this.ref)
            this.ref.stepUp(1);

          setSelectedTime(selectedTime + 1);
        }
      }, 1500);
    }
  }

  render() {
    const { workOrderStore, workOrderStatusStore, maintenanceTypeStore, priorityStore } = this.props;
    const { timeRange, selectedTime } = workOrderStore;

    // const {mapCenter, markers, markerIcons} = this.state;
    const markers = workOrderStatusStore.items.length > 0 && priorityStore.items.length > 0 && maintenanceTypeStore.items.length > 0
      ? workOrderStore.getMarkers()
      : [];

    const markerIcons = this.getFilteredMarkerIcons(markers);
    let mapCenter = getCenter(markerIcons);

    return (
      <div className='full-width'>
        <div className='ticket-list-map'>
          <div className='flex-grow ticket-map'>
            <LeafletMap id='ticket_map'
              center={mapCenter}
              markers={markerIcons}
              selectedMarker={workOrderStore.selectedMarker}
              width='100%'
              onMarkerClick={this.onMarkerClick}
              isLoading={workOrderStore.isLoading}
              onMarkerOver={workOrderStore.onMarkerOver}>
              {workOrderStore.selectedMarker && markers.find(item => +item.station_id === +workOrderStore.selectedMarker) ? <div
                className='map-info-box'>{this.getPopupBox(markers.find(item => +item.station_id === +workOrderStore.selectedMarker))}</div> : null}
            </LeafletMap>
          </div>
          <div>
            <WorkOrderInfoTable />
          </div>
        </div>
        {timeRange.length >= 2 && <div>
          <div style={{ cursor: 'pointer', margin: '10px' }} onClick={this.startInterval}>
            <i className={`fa fa-${this.playing ? 'pause' : 'play'}`} />
          </div>
          <StepRangeSlider
            ref={(ref) => this.ref = ref}
            value={selectedTime}
            range={timeRange}
            onChange={this.onChangeSelectedTime}
            children={null}
          // children={<span style={{marginTop: '10px', width: '50px'}}>{moment().dayOfYear(this.selected_date).format('YYYY-MM-DD')}</span>}
          />
          {!!timeRange[selectedTime] && <span style={{
            marginLeft: `calc(${(selectedTime / (timeRange.length - 1)) * 100}% - (${(selectedTime / (timeRange.length - 1)) * 126}px))`,
            whiteSpace: 'nowrap',
            transition: '0.1s linear'
          }}>{getDisplayDate(timeRange[selectedTime].date, { format: 'YYYY-MM-DD HH:mm' })}</span>}
          {/* <div className='flex flex-row space-between'>{this.timeRange.map(item => <span key={`timeline-labe-${item.value}`} style={{ cursor: 'pointer', color: 'gray', fontSize: 14 }} onClick={() => this.onChangeSelectedDate(item.value)}>{this.selectedTime === item.value ? getDisplayDate(item.date, { format: 'YYYY-MM-DD HH:mm' }) : ''}</span>)}</div> */}
        </div>}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderMapLeaflet.js